import React from 'react';
import { useSelector } from 'react-redux';

import WomenMenCancerImage from '../../assets/images/death_reasons/womenMenCancerImage';
import MenCancerEng from '../../assets/images/death_reasons/menCancerEng';
import MenCancerRus from '../../assets/images/death_reasons/menCancerRus';
import Border from '../../assets/images/border';

import './men_cancer.scss';

const MenCancer = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='menCancer'>
            <Border />
            {language === 'ENG' ? <MenCancerEng /> : <MenCancerRus />}
            <WomenMenCancerImage />
            <span className='menCancer-text'>
                {language === 'RUS' ? 'Каждому восьмому мужчине при жизни будет диагностирован рак предстательной железы. Риск сохраняется, даже несмотря на здоровый образ жизни. Поэтому не лишним будет регулярно обследоваться.' : 'One in eight men will be diagnosed with prostate cancer during their lifetime. The risk remains, even with a healthy lifestyle. Therefore, regular screenings are recommended.'}
            </span>
        </div>
    );
};

export default MenCancer;